import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { Language } from './update-language.types'

const updateLanguage = async (language: Language): Promise<void> => {
  await apiClient.patch('/v1/administration/profile/language', { language })
}

export const useUpdateLanguage = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (language: Language) => updateLanguage(language),
    meta: {
      ...feedback,
    },
  })
}
